import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import UploadLocations from './../UploadLocations';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import Loader from './../../../../shared/components/loader';
import MasterService from '../../../services/clientmanagement.service';
import CONSTANT from './../../../../shared/constants/constant'
import Util from './../../../../shared/util/util'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ClientServicesListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    UploadLocations,
    Loader,
    CustomExpandableTable,
    Multiselect
  },
  data: function() {
    return {
      companyNamelist: [],
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      companyName: '',
      clientId: '',
      tableColumn: [],
      totalCount: 0,
      tableItems: [],
      showServiceFlag: false,
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      offset: 0,
      selectedContractServiceObj: '',
      fltlocation: '',
      isLoading: false,
      locationlist: [{
        text:'Pickup',
        value: 'pickup'
      },{
        text: 'Consignee',
        value: 'consignee'
      }],
      selectedlocationtype: {
        text:'Pickup',
        value: 'pickup'
      },
      fltlocationtype: 'pickup',
    }
  },
  computed: {},
  mounted() {
    this.getCompanyShortName();
    this.getUploadLocationList()
  },
  methods: {

    async getCompanyShortName() {
      try {
        let inputPayload = {}
        var CompanyShortList = []
        let result = await MasterService.GetCargoClientList(inputPayload)
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          if(CompanyShortList[i].ClientShortName){
            this.companyNamelist.push({
              'value': CompanyShortList[i].ClientMasterID,
              'text': CompanyShortList[i].ClientShortName,
              'CompanyName': CompanyShortList[i].AccountName,
              'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
            })
          }
        }
      } catch (err) {
        console.log(err);
      }
    },

    showUploadLoad() {
      this.showServiceFlag = true;
    },

    async getUploadLocationList() {
      this.isLoading = true;
      let result
      try {
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if (this.companyName ) {
          inputPayload.clientid = this.clientid;
          inputPayload.clientbusinessaccountid = this.clientbusinessaccountid;

        }
        if (this.fltlocation != '') {
          inputPayload.fltlocation = this.fltlocation;
        }
        if(this.fltlocationtype == 'pickup'){
          this.tableColumn = ['Client System ID', 'Client Business Account ID','Pincode', 'Location Name','Address','Mobile','Telephone','Email','GSTIN','Created By','Created Date','Last Modified By','Last Modified Date']
          result = await MasterService.getUploadLocationListForPickup(inputPayload);
        }
        if(this.fltlocationtype == 'consignee'){
          this.tableColumn = ['Client System ID','Pincode', 'Consignee Code', 'Company Name','Address','Mobile','Telephone','Email', 'Attn','GSTIN','Created By','Created Date','Last Modified By','Last Modified Date']
          result = await MasterService.getUploadLocationListForConsignee(inputPayload);
        }
        this.isLoading = false;
        this.tableArr = result.data.data.rows;
        if(this.fltlocationtype == 'pickup'){
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Client System ID': el.clientid,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Pincode': el.pincode,
              'Location Name': el.locationname,
              'Address': el.address,
              'Mobile':el.mobile,
              'Telephone': el.telephone,
              'Email': el.email,
              'GSTIN': el.gstno,
              'Created By': el.createdby,
              'Created Date': Util.displayDateOnlyFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
            }
          })
        }else if(this.fltlocationtype == 'consignee'){
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Client System ID': el.clientid,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Pincode': el.pincode,
              'Consignee Code': el.consigneecode,
              'Company Name': el.consigneename,
              'Address': el.address,
              'Mobile':el.mobile,
              'Telephone': el.telephone,
              'Email': el.email,
              'Attn': el.attn,
              'GSTIN': el.csttin,
              'Created By': el.createdby,
              'Created Date': Util.displayDateOnlyFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
            }
          })
        }
        this.totalCount = result.data.data.count;
        if (this.totalCount < 10) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / 10);
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },

    selectCompanyName(data) {
      this.selectedcompanyName = data;
      this.companyName = data.text;
      this.clientid = data.value
      this.clientbusinessaccountid = data.ClientBusinessAccountId
    },

    selectLocationType(data) {
      this.selectedlocationtype = data;
      this.fltlocationtype = data.value
    },

    callParent() {
      this.showServiceFlag = false;
      this.currentPage = 1;
      this.offset = 0;
      this.getUploadLocationList();
    },

    searchLocation() {
      this.currentPage = 1;
      this.offset = 0;
      this.getUploadLocationList();
    },

    resetLocation() {
      this.currentPage = 1;
      this.offset = 0;
      this.companyName = "";
      this.fltlocation = "";
      this.clientid = ''
      this.selectedcompanyName = {};
      this.selectedlocationtype = {
        text:'Pickup',
        value: 'pickup'
      }
      this.fltlocationtype = 'pickup'
      this.getUploadLocationList();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getUploadLocationList();
    },

    // getCustomTableEvent(event) {
    //   if (event.actionType == "view") {
    //     this.createTemplatesFlag = true;
    //   }else if (event.actionType == "edit") {
    //     let selectedContractObj = this.tableArr.filter(function(Items) {
    //       return Items.id == event.id;
    //     });
    //     this.selectedContractObj = selectedContractObj[0];
    //     this.showServiceFlag = true;
    //   }
    // },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientLocations/UploadLocationListing/UploadLocationListing.component.js